// "מה חדש" popup content — shown once per user per version when enabled.
// To activate: set enabled: true (and edit the items freely). The popup
// records `kup-whatsnew-seen-{userId}` in localStorage after dismissal, so a
// new `version` here is what shows it again — update it with every release
// users should hear about.
export const WHATS_NEW = {
  version: '5.0.0',
  enabled: true,
  title: 'מה חדש מאז העדכון האחרון',
  items: [
    { icon: '🏆', text: 'עמוד דירוגים חדש: השנה, החודש והיום במבט אחד, פודיום וטבלה, ודירוג לפי גיל, מפיץ, ז׳אנר, מדובב לעברית, ישראלי ו-IMAX' },
    { icon: '✨', text: '"מה חדש": הסופ״ש במרכז עם פודיום, היום והסופ״ש הקרוב בצד, ומכירות מוקדמות של סרטים שעוד לא עלו' },
    { icon: '📊', text: 'טבלאות בעיצוב חדש: יום, סופ״ש, שבוע או טווח, עם חיצים לתקופה הקודמת והבאה — גם קדימה, למכירה מוקדמת' },
    { icon: '📅', text: '"ארכיון" הפך ל"סופי שבוע": הסופ״שים הגדולים של השנה, וכל סופ״ש עם המקום שלו, התפוסה והחג' },
    { icon: '🏢', text: 'סניפים כמו הדירוגים: שנה, חודש, סופ״ש והיום, רשתות, סניפים וערים — והסרט המוביל בכל אחד' },
    { icon: '🎬', text: '"סרטים" הפך לארכיון: כל הסרטים לפי א׳-ב׳, וכברירת מחדל רק אלה שעוד מוקרנים' },
    { icon: '🍿', text: 'סרט שנפתח בהקרנות טרום-בכורה ביום רביעי — הרביעי נספר בסופ״ש שלו ומסומן "כולל רביעי"' },
    { icon: '📱', text: 'עמוד הסרט בטלפון: כל הלשוניות על המסך, וההקרנות ברשימה לפי ימים' },
    { icon: '🔄', text: 'תיקוני נתונים: הקרנה שעברה לאולם אחר נספרת פעם אחת, וסינמה סיטי נאספת שוב אחרי שינוי באתר שלה' },
  ],
};
